const homeSlider = () => {
  const slider = $('.js-home-slider');

  if (slider.length) {
    slider.slick({
      fade: true,
      pauseOnHover: false,
      pauseOnFocus: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 6000,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            arrows: false,
            dots: true,
            draggable: true,
          },
        },
      ],
    });
  }
}

export default homeSlider;
